import PlayerManager from "./player-manager";
import SocketService from "./socket";
import UIManager from "./ui-manager";
import RedirectService from "./redirect-service";

const P = () => {
  const { isPlaying } = PlayerManager.getState();
  if (isPlaying) {
    PlayerManager.pause();
    SocketService.pause();
  } else {
    PlayerManager.resume();
    SocketService.resume();
  }
};

const E = () => {
  UIManager.togglePlayer();
};

const M = () => {
  UIManager.toggleMiniMode();
};

const F = () => {
  UIManager.toggleFullScreen();
};

// go to current Room
const R = () => {
  const roomState = SocketService.getState();
  const {
    isJoined,
    room: { id: roomId },
  } = roomState;
  if (isJoined) RedirectService.redirect(`/room/${roomId}`);
};

const RightArrow = () => {
  SocketService.next();
  PlayerManager.playNext();
};

const LeftArrow = () => {
  SocketService.prev();
  PlayerManager.playPrev();
};

export default () => {
  const onKeyDown = (e) => {
    const isActionNeeded = !e.shiftKey && e.ctrlKey;
    if (!isActionNeeded) return;
    const keys = [77, 82, 69, 70, 80, 37, 39];
    for (let i = 0; i < keys.length; i++)
      if (keys[i] === e.keyCode) {
        e.preventDefault();
        break;
      }
    switch (e.keyCode) {
      case 77:
        return M();
      case 82:
        return R();
      case 69:
        return E();
      case 70:
        return F();
      case 80:
        return P();
      case 37:
        return LeftArrow();
      case 39:
        return RightArrow();
    }
  };
  document.addEventListener("keydown", onKeyDown, false);
};
